import { scrollContextFactory } from '../../../contexts/scrollContext';

export const { ScrollProvider: ChatScrollProvider, useScrollContext: useChatScrollContext } =
  scrollContextFactory();
